module.exports = __webpack_public_path__ + "img/1-1.72e859e9.jpg";